import { Component, PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as titleActions from './title.actions';

export class Title extends Component {
  componentDidMount() {
    const { titleActions, title } = this.props;
    titleActions.updateTitle(title);
    titleActions.updateMessage(title + ', view loaded');
  }

  componentWillUnmount() {
    const { titleActions } = this.props;
    titleActions.updateTitle(null);
    titleActions.updateMessage(null);
  }

  render() {
    return null;
  }
}

Title.propTypes = {
  title: PropTypes.string.isRequired
};

const mapStateToProps = () => {
  return {
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    titleActions: bindActionCreators(titleActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Title);



// WEBPACK FOOTER //
// src/layout/title.js